/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type V1DeploymentsCreateDeploymentResponseData = {
  /**
   * Unique deployment identifier. Poll deployments.getDeployment with this id to watch status.
   */
  deploymentId: string;
};

/** @internal */
export const V1DeploymentsCreateDeploymentResponseData$inboundSchema: z.ZodType<
  V1DeploymentsCreateDeploymentResponseData,
  z.ZodTypeDef,
  unknown
> = z.object({
  deploymentId: z.string(),
});

export function v1DeploymentsCreateDeploymentResponseDataFromJSON(
  jsonString: string,
): SafeParseResult<
  V1DeploymentsCreateDeploymentResponseData,
  SDKValidationError
> {
  return safeParse(
    jsonString,
    (x) =>
      V1DeploymentsCreateDeploymentResponseData$inboundSchema.parse(
        JSON.parse(x),
      ),
    `Failed to parse 'V1DeploymentsCreateDeploymentResponseData' from JSON`,
  );
}
